import { render } from "./MindTab.vue?vue&type=template&id=bcbd6ba0&scoped=true"
import script from "./MindTab.vue?vue&type=script&lang=js"
export * from "./MindTab.vue?vue&type=script&lang=js"

import "./MindTab.vue?vue&type=style&index=0&id=bcbd6ba0&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcbd6ba0"]])

export default __exports__